import type { AbilityDef } from "../../sim";

/**
 * Захват L1 (Джон 04.11.2026, 23:25–23:26): бросок через плечо по паре клипов Shoulder Throw — путь и урон в
 * sim/throw.ts; промах (далеко, в воздухе) — короткий хват мимо, его можно наказать.
 */
export const SHOULDER_THROW: AbilityDef = {
  id: "shoulder-throw",
  name: "Бросок через плечо",
  input: { grab: true },
  pose: "throwAggressor",
  startup: 80,
  active: 0,
  recovery: 0,
};

export const GRAB_WHIFF: AbilityDef = {
  id: "grab-whiff",
  name: "Захват мимо",
  input: { grabWhiff: true },
  pose: "grabWhiff",
  startup: 4,
  active: 0,
  recovery: 22,
};
